import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, API, buildError } from '../../api/apis';
import { ApiResponse, AssociateBillingAccessCodeRequest, AssociateBillingAccessCodeResponse } from '../../interfaces/interfaces';

export const scmBillingAssociationService = createApi({
  reducerPath: 'scmBillingAssociationApi',
  tagTypes: ['ScmBillingAssociation'],
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    associateBillingAccessCode: builder.mutation({
      query: ({ payload, headers }: { payload: AssociateBillingAccessCodeRequest, headers: HeadersInit }) => ({
        url: `${API.ASSOCIATE_BILLING_ACCESS_CODE()}`,
        method: 'POST',
        body: payload,
        headers
      }),
      transformResponse: (response: ApiResponse) => {
        return response.Response as AssociateBillingAccessCodeResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAssociateBillingAccessCodeMutation } = scmBillingAssociationService;
